import partnerLogoUrl from '../partners/partnerLogoUrl';

// A task target named by a piid is a partnership, not a person or a team. The
// inbound side is in the session's partner list; the outbound side is only known
// through the external group the invite created here.
const resolvePartnerTarget = (piid, { authInfo, groupsMap }) => {
  const partner = authInfo?.partners?.find((thisPartner) => (thisPartner.piid === piid));
  if (partner) {
    return {
      label: partner.lbl,
      logoUrl: partnerLogoUrl(partner.backUrl, partner.cuid, partner.logoId, partner.wideLogoId),
    };
  }

  const groups = [...(groupsMap?.values() ?? [])];
  const group = groups.find(
    (thisGroup) => thisGroup.isExternal?.invites?.some((invite) => (invite.piid === piid)),
  );
  if (!group) return null;

  const { isExternal } = group;
  return {
    label: isExternal.cstmrLbl ?? group.grpLbl,
    logoUrl: partnerLogoUrl(
      isExternal.backToCstmr,
      isExternal.cuid,
      isExternal.logoId,
      isExternal.wideLogoId,
    ),
  };
};

export default resolvePartnerTarget;
